import { MaterialIcon } from 'shared/ui/MaterialIcon';
import type { HistoryModels } from 'entities/history';

interface EventDetailsCellWithJsonColumn {
  className?: string;
  entityId: number;
  jsonDownloader: (
    entityId: number,
    historyId: number
  ) => {
    isLoading: boolean;
    download: (paramsForUrl?: Record<string, string> | undefined) => Promise<void>;
  };
  row: HistoryModels;
}
export function EventDetailsCellWithJsonColumn({
  className,
  entityId,
  jsonDownloader,
  row,
}: EventDetailsCellWithJsonColumn) {
  if ('isDownloadable' in row && !row.isDownloadable) {
    return <td />;
  }
  if (!('historyId' in row)) {
    return <td />;
  }

  const useDownloadFileQuery = jsonDownloader(entityId, row.historyId);

  return (
    <td className={className}>
      <MaterialIcon
        className="text-[20px] text-slate-300 hover:text-deep-blue-500"
        onClick={useDownloadFileQuery.download as unknown as (event: React.MouseEvent<HTMLElement>) => void}
      >
        file_download
      </MaterialIcon>
    </td>
  );
}
